import { z } from 'zod';
/** Canonical unit vocabulary shared by recipes, pantry, lists and the seed files. */
export const UNIT_KEYS = [
    // mass
    'g',
    'kg',
    'oz',
    'lb',
    // volume
    'ml',
    'l',
    'tsp',
    'tbsp',
    'fl_oz',
    'cup',
    'pint',
    'quart',
    'gallon',
    // count-ish
    'count',
    'clove',
    'slice',
    'can',
    'package',
    'stick',
    'bunch',
    'pinch',
    'dash',
    'to_taste',
    // appended after the ~2,400-recipe scrape review (unit_keys_v2 migration)
    'sprig',
    'head',
    'stalk',
    'jar',
    'bag',
    'box',
    'container',
    'link',
    'strip',
    'piece',
    'fillet',
    'ear',
    'leaf',
];
export const unitKeySchema = z.enum(UNIT_KEYS);
export const EQUIPMENT_KINDS = [
    'oven',
    'burner',
    'grill',
    'microwave',
    'slow_cooker',
    'air_fryer',
    'sous_vide',
];
export const equipmentKindSchema = z.enum(EQUIPMENT_KINDS);
export const STORAGE_LOCATIONS = ['pantry', 'fridge', 'freezer'];
export const storageLocationSchema = z.enum(STORAGE_LOCATIONS);
export const idSchema = z.uuid();
export const slugSchema = z
    .string()
    .min(1)
    .max(120)
    .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'lowercase words separated by single hyphens');
//# sourceMappingURL=common.js.map